<template>
  <div class="setting">
    <v-container>
      <h2 class="mb-2">Settings</h2>
      <div class="test">
        <p>Customerの設定</p>
      </div>
      <v-col align="right"><v-btn @click.once="back">戻る</v-btn></v-col>
      <v-row>
        <v-col cols="12" sm="6">
          <h3 class="mb-2">Customer名</h3>
          <v-text-field
            v-model="json.name"
            :class="[`mb-4`]"
            placeholder="customer名を入力してください。"
            background-color="white"
            outlined
            hide-details="auto"
          ></v-text-field>
          <h3 class="mb-2">詳細</h3>
          <v-text-field
            v-model="json.detail"
            :class="[`mb-4`]"
            placeholder="詳細"
            background-color="white"
            outlined
            hide-details="auto"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="center" class="mt-4">
        <v-btn @click="modalOpen" color="primary">cusotomerの作成</v-btn>
      </v-row>
      <v-dialog v-if="check_dialog" v-model="check_dialog" max-width="350">
        <check-dialog
          v-on:clickSubmit="modalClose"
          :message="'customerを生成しますか?'"
        />
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import checkDialog from "../../components/CheckDialog/CheckDialog";
import { RepositoryFactory } from "../../api/RepositoryFactory";
const api = RepositoryFactory.get("api2");

export default {
  name: "Index",
  components: {
    checkDialog,
  },
  data: () => ({
    drawer: true,
    json: {
      name: "",
    },
    check_dialog: false,
  }),
  methods: {
    modalOpen() {
      if (this.json.name != "") {
        this.check_dialog = true;
      }
    },
    modalClose(value) {
      this.check_dialog = false;
      if (value) {
        this.customerGenerate();
      }
    },
    async customerGenerate() {
      const respose = await api.cusotmerGenerate(this.json);
      if (respose.result == "Duplicate") {
        alert("名前が重複しています");
      } else {
        alert("生成完了");
      }
      console.log(respose);
    },
    back() {
      history.back();
    },
  },
};
</script>
